import { welcomeData } from "../../config/homePageUtils";
import Button from "../common/Button";
import Image from "../common/Image";
import { useLanguage } from "../LanguageProvider/LanguageProvider";

const WelcomeSection = ({ data = welcomeData }) => {
  const { language } = useLanguage();
  return (
    <section className="bg-white py-24 welcome-section">
      <div className="container mx-auto px-4 flex flex-col md:flex-row items-center gap-14">
        {/* Image Column */}
        <div className="md:w-1/2 relative group">
          <Image
            src={data.image}
            alt={data.highlight}
            className="rounded-lg w-full max-w-xl mx-auto transform transition-transform duration-300 group-hover:scale-110"
          />

          {/* Badge */}
          <div className="absolute bottom-4 right-4 bg-[#018f9b] text-white px-4 py-4 rounded shadow-lg">
            <p className="font-bold text-lg leading-tight border-b text-white">
              {language ? data.badge.rank.hi : data.badge.rank.en}
            </p>
            <p className="text-sm leading-tight py-3 whitespace-pre-line text-white">
              {language ? data.badge.text.hi : data.badge.text.en}
            </p>
          </div>
        </div>

        {/* Text Column */}
        <div className="md:w-1/2 text-block content">
          <h2 className="font-bold mb-4 section-heading text-left">
            {
              (language ? data.title.hi : data.title.en).split(
                data.highlight,
              )[0]
            }
            <span className="text-[#018f9b] font-bold section-heading">
              {" "}
              {language ? data.highlight.hi : data.highlight.en}
            </span>
            <div className="w-24 h-1 bg-[#018f9b] mt-2"></div>
          </h2>

          <p className="text-gray-600 mb-6 mt-6">
            {language ? data.description.hi : data.description.en}
          </p>

          <Button
            onClick={() =>
              window.open(data.buttonLink, "_blank", "noopener,noreferrer")
            }
            className="inline-flex items-center bg-[#018f9b] text-white px-6 py-3 rounded-full font-medium hover:bg-[#000] transition"
          >
            {language ? data.buttonText.hi : data.buttonText.en}{" "}
            <span className="ml-2 text-lg text-white">→</span>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default WelcomeSection;
